import { render, staticRenderFns } from "./PrivateRoomMenu.vue?vue&type=template&id=438e4af9"
import script from "./PrivateRoomMenu.vue?vue&type=script&lang=ts"
export * from "./PrivateRoomMenu.vue?vue&type=script&lang=ts"
import style0 from "./PrivateRoomMenu.vue?vue&type=style&index=0&id=438e4af9&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438e4af9')) {
      api.createRecord('438e4af9', component.options)
    } else {
      api.reload('438e4af9', component.options)
    }
    module.hot.accept("./PrivateRoomMenu.vue?vue&type=template&id=438e4af9", function () {
      api.rerender('438e4af9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoCard/PrivateRoomMenu.vue"
export default component.exports